import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SuperAdminPageLayout from '../../../layout/SuperAdminPageLayout';
import { useParams } from 'react-router-dom';
import { getInstitution } from '../../../api/admin/institutions';
const SuperAdminCreateEditorPage = () => {
    const { id } = useParams();
    const { t } = useTranslation();
    const [institutionName, setInstitutionName] = useState('');
    useEffect(() => {
        const getInstitutionName = async () => {
            const institution = await getInstitution(id);
            setInstitutionName(institution.institution.name);
        };
        if (id) {
            getInstitutionName();
        }
    }, [id]);
    return (_jsx(SuperAdminPageLayout, { title: `${t('admin.create_new_editor')} ${t('label.for')} ${institutionName}.`, formType: 'create', unit: 'editor', institutionId: id }));
};
export default SuperAdminCreateEditorPage;
